import React from 'react';
import PropTypes from 'prop-types';

export default function DataManager(props) {
  return (
    <svg width={20} height={18} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 5H6.001L6 17H4V5H0L5 0L10 5ZM20 13L15 18L10 13H14V1H16V13H20Z" fill={props.color || '#8E8E92'} />
    </svg>
  );
}

DataManager.propTypes = {
  color: PropTypes.string
};
